import * as React from "react"
import trans from "trans"
import Mergado from "app/helpers/mergado"

import {
    DataCell,
    Theme,
    Select,
    Grid,
    GridCell,
    Icon,
    css,
    modal,
} from "@bdfx/mergado-ui-kit"

import {isGodModeOn, projectId} from "app/helpers/api";
import {ExtendedProductType} from "../types";

import {
    availableWatermarksOptionsMistakeByUser,
    renderItemId,
    renderName, SetByUser,
} from "./product-table";

import {URL} from "app/config/api-config";
import {DarkGrayColor} from "app/helpers/colors";
import {isJson} from "app/helpers/other";
import {StyledDataRow} from "./product-table-table";
import { allowSuperadminForUsers } from "template-edit/components/helper";
import { WatermarksRenderSvgObjects } from "./render-objects-helper";

interface Props {
    showAlternativeImages: boolean
    product: ExtendedProductType
    getEmptyFiltersForm: Function
    showModal: Function
    idx: number
    changeSetByUser: Function
    updateWatermarkMasksFromDb: Function
    userId: number
}

const MERGADO_APP = `https://app.mergado.com/projects/${projectId}/product`

class WatermarkRow extends React.Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    renderWatermarkMask = (product: ExtendedProductType, altLevel?: number) => {
        const isAlt = typeof altLevel === 'number'

        const objects = isAlt ? product.alternative_images[altLevel]?.alt_watermark_masks?.user_set_objects : product.masks_user_set_objects
        const imageUrl = isAlt ? product.alternative_images[altLevel]?.url : product.image_url
        const width = isAlt ? product.alternative_images[altLevel]?.width : product.image_width
        const height = isAlt ? product.alternative_images[altLevel]?.height : product.image_height
        const key = isAlt ? `a${product.alternative_images[altLevel]?.id}` : `i${product.image_id}`

        return <GridCell key={key} className={'image-item'}>
            <div className={'image'}>
                <StyledSvg version="1.1" viewBox={`0 0 ${width} ${height}`} height={50} className={'clickable'}>
                    <g>
                        <image
                            className={'shadow-box checker'}
                            width={width}
                            height={height}
                            xlinkHref={imageUrl}
                        />
                        <WatermarksRenderSvgObjects objects={isJson(objects) ? JSON.parse(objects) : objects} color={Theme.blue} opacity={.8} />
                    </g>
                </StyledSvg>
            </div>
        </GridCell>
    }

    render() {
        const {product, idx, userId, showAlternativeImages} = this.props
        const icon = (status) => {
            switch (status) {
                case 'OK':
                    return <Icon type={'check'} color={Theme.green} text={trans('has_no_watermark')} />
                case 'ERROR':
                    return <Icon type={'exclamation'} color={Theme.red} text={trans('status_'+product.watermarks_status)} />
                case 'N/A':
                    return <Icon type={'question'} color={DarkGrayColor} text={trans('status_'+product.watermarks_status)} />
                case 'NOT_OK':
                    return <Icon type={'paw'} color={Theme.red} text={trans('has_watermark')} />
                default:
                    return <Icon type={'close-light'} color={DarkGrayColor} text={trans('status_'+product.watermarks_status)} />
            }
        }

        const addStatusClass = (product.watermarks_status === 'OK') ? 'ok' : (product.watermarks_status === 'ERROR' ? 'error' : (product.watermarks_status === 'NOT_OK' ? 'not-ok' : ''))

        const timeStamp = new Date(product.rendered_at).getTime()

        const mergadoProductUrl = `${MERGADO_APP}/${product.product_id}`
        const previewUrl = `${URL.laravelBase}images?template_id=${product.template_id}&product_id=${product.product_id}&nocache=1`
        const wmremovedUrl = `${URL.laravelBase}get-wmremoved/${product.project_id}/${product.image_url_hash}?t=${timeStamp}`


        return <StyledDataRow dataId={product.image_id} key={`${product.image_id}`}>
            {isGodModeOn &&
            <DataCell key={'image_id'}>{product.image_id}</DataCell>
            }

            <DataCell key={'product_image'}>
                <ProductImageGrid cols={'1fr max-content 1fr'} className={'clickable'} onClick={() => this.props.showModal(idx)} title={trans('edit')}>
                    <GridCell col={product.masks_user_set_objects ? undefined : 'span 3'}>
                        {product.masks_user_set_objects ? this.renderWatermarkMask(product) : <img className={'shadow-box checker'} src={product.image_link} height={50} />}
                    </GridCell>

                    {product.masks_user_set_objects &&
                    <GridCell>
                        <Icon type={'arrow-right-light'} size={20} color={Theme.steelblue}/>
                    </GridCell>
                    }

                    {product.masks_user_set_objects &&
                    <GridCell>
                        <img src={wmremovedUrl} height={50} loading="lazy"/>
                    </GridCell>
                    }
                </ProductImageGrid>

                {product.alternative_images && product.alternative_images.map(alt => {
                    const altWmremovedUrl = `${URL.laravelBase}get-alt-wmremoved/${product.project_id}/${alt.url_hash}?t=${timeStamp}`

                    return <ProductImageGrid cols={'1fr max-content 1fr'} key={`alt_${alt.id}`} className={'clickable'} onClick={() => this.props.showModal(idx, alt.level)} title={trans('edit')}>
                        <GridCell col={alt.alt_watermark_masks?.user_set_objects ? undefined : 'span 3'}>
                            {alt.alt_watermark_masks?.user_set_objects ? this.renderWatermarkMask(product, alt.level) : <img className={'shadow-box checker'} src={alt.url} height={50} />}
                        </GridCell>

                        {alt.alt_watermark_masks?.user_set_objects &&
                            <GridCell>
                                <Icon type={'arrow-right-light'} size={20} color={Theme.steelblue} />
                            </GridCell>
                        }

                        {alt.alt_watermark_masks?.user_set_objects &&
                            <GridCell>
                                <img src={altWmremovedUrl} height={50} loading="lazy" />
                            </GridCell>
                        }
                    </ProductImageGrid>
                }
                )}
            </DataCell>

            {showAlternativeImages &&
                <DataCell key={'alternative_images'} className='clickable centered'>
                    {product.alternative_images &&
                        <Grid cols="repeat(3, 1fr)">
                            {product.alternative_images.map((a, level) => {
                                return <GridCell key={'alt' + a.id}>
                                    <img src={a.url} width="40" onClick={() => this.props.showModal(idx, level)} title={trans('edit')} />
                                </GridCell>
                            })}
                        </Grid>
                    }
                </DataCell>
            }

            <DataCell key={'product_name'} className='clickable left'>
                {renderName(product.elements_name)}
                <br/>
                {renderItemId(product.elements_item_id)}
            </DataCell>

            <DataCell key={'status'} className={`left ${product.watermarks_user_set ? '' : 'status '} ${addStatusClass}`}>
                {product.watermarks_user_set !== null ?
                    <span>({trans('set_by_user')})</span> : icon(product.watermarks_status)
                }

                {product.watermarks_status !== null &&
                    <Select
                        value={product.watermarks_user_set !== null ? `${product.watermarks_user_set}` : null}
                        options={availableWatermarksOptionsMistakeByUser}
                        onChange={(value) => this.props.changeSetByUser(product.image_id, idx, (value !== '100' ? parseInt(value) : null))}
                    />
                }
            </DataCell>

            {userId && (allowSuperadminForUsers.includes(userId)) &&
            <DataCell key={'status_reason'}>{trans(product.watermarks_status_reason)}</DataCell>
            }

            <DataCell key={'confidence'}>{product.watermarks_probability && product.watermarks_probability}</DataCell>

            <DataCell key={'links'} className='centered clickable'>
                <Grid cols={`repeat(4, 1fr)`} className={'product-links'}>
                    {product.image_link &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(product.image_link)} title={trans("link_image_url")}>
                        <Icon type={'file-image-o'} color={Theme.blue} size={20} />
                        </div>
                    </GridCell>
                    }
                    {previewUrl &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(previewUrl)} title={trans("link_fie")}>
                        <Icon type={'feedimageeditor'} size={20} />
                        </div>
                    </GridCell>
                    }
                    {mergadoProductUrl &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(mergadoProductUrl)} title={trans("link_mergado")}>
                        <Icon type={'mergado'} size={20} />
                        </div>
                    </GridCell>
                    }
                    {product.elements_url &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(product.elements_url)} title={trans("link_eshop")}>
                        <Icon type={'shopping-basket'} color={DarkGrayColor} size={20} />
                        </div>
                    </GridCell>
                    }
                </Grid>
            </DataCell>
        </StyledDataRow>
    }
}

const StyledSvg = css('svg')({
    width: 'auto',
    height: 'auto',
    maxWidth: '120px',
    maxHeight: '120px',
})

const StyledGrid = css(Grid)({
    ' img.preview-img': {
        maxWidth: '100%',
        maxHeight: '50vh',
    },
    ' .muk-gridcell': {
        alignSelf: 'center',
        textAlign: 'center',
    }
})

const ProductImageGrid = css(Grid)({
    ' .muk-gridcell': {
        alignSelf: 'center',
        textAlign: 'center',
    }
})

export default WatermarkRow

